import { render, staticRenderFns } from "./ProductItemWithImage.vue?vue&type=template&id=2118b02d&scoped=true&"
import script from "./ProductItemWithImage.vue?vue&type=script&lang=ts&"
export * from "./ProductItemWithImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductItemWithImage.vue?vue&type=style&index=0&id=2118b02d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2118b02d",
  null
  
)

export default component.exports